import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import AuthorizationWrapper from "@/utilities/authorization/AuthorizationWrapper.vue";
import MenuWrapper from "@/utilities/menu/MenuWrapper.vue";
import { onUnmounted } from "vue";
import { createUser } from "./services/useUser";
import { useStore } from "./store";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
createUser();

/** The maximum window width before adjustZoom prevents further zooming */
const MAX_DESKTOP_WIDTH = 2560;
/** The minimum window width before adjustZoom prevents further zooming */
const MIN_DESKTOP_WIDTH = 960;
/** The maximum window width of the mobile site */
const MAX_MOBILE_WIDTH = 480;
/** The minimum mobile window width before adjustZoom prevents further zooming */
const MIN_MOBILE_WIDTH = 400;
/** The root font size to set in pixels (used to scale the whole page) default == 16 */
const ROOT_FONT_SIZE = 16;

/** Get the current rem scaling factor */
const getScalingFactor = function () {
  let scalingFactor = 1;
  if (window.innerWidth > MAX_DESKTOP_WIDTH) scalingFactor = window.innerWidth / MAX_DESKTOP_WIDTH;
  else if (window.innerWidth < MIN_DESKTOP_WIDTH && window.innerWidth > MAX_MOBILE_WIDTH)
    scalingFactor = window.innerWidth / MIN_DESKTOP_WIDTH;
  else if (window.innerWidth < MIN_MOBILE_WIDTH) scalingFactor = window.innerWidth / MIN_MOBILE_WIDTH;
  return scalingFactor;
};

const root = document.querySelector(":root") as HTMLElement;
root.style.fontSize = `${ROOT_FONT_SIZE}px`;

/** Increase adjust the size of an rem to account for extreme screen sizes */
const adjustZoom = function () {
  const scalingFactor = getScalingFactor();
  if (scalingFactor !== 1 || window.innerWidth < MAX_MOBILE_WIDTH) {
    const root = document.querySelector(":root") as HTMLElement;
    root.style.fontSize = `${ROOT_FONT_SIZE * scalingFactor}px`;
  }
  if (window.innerWidth <= MAX_MOBILE_WIDTH !== store.state.isMobile)
    store.state.isMobile = window.innerWidth <= MAX_MOBILE_WIDTH;
  store.state.viewWidth = window.innerWidth;
};
adjustZoom();
window.addEventListener("resize", adjustZoom);
onUnmounted(() => window.removeEventListener("resize", adjustZoom));

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(AuthorizationWrapper, null, {
    default: _withCtx(() => [
      _createVNode(MenuWrapper, null, {
        default: _withCtx(() => [
          _createVNode(_component_RouterView)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})